/// <summary>                                 
/// ODataBr - Generate NG5 Script                           
/// Date: 18/02/2018 14:28:12                          
/// Auth:  amarildo lacerda - tireideletra.com.br           
///        gerado pelo Servidor ODataBr: .../OData/hello/ng   
/// </summary>                                 

import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ODataProviderService,ODataFactory,ODataService } from './odata-provider.service';
import { Observable } from 'rxjs/Rx';
import { ODataBrServiceBase } from './odatabr.service-base'; 

export interface ODataBrQuery extends ODataService { } 

@Injectable()
export class ODataBrProvider extends ODataBrServiceBase {

constructor (public _odata:ODataProviderService){
  super(_odata);
}
   get_filial( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "filial"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_produtos( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "produtos"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_produto_alergicos( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "produto_alergicos"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_produto_composicao( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "produto_composicao"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_setores( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "setores"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_atalhos( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "atalhos"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_atalho_itens( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "atalho_itens"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_grupos( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "grupos"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   put_grupos( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.putItem("grupos", item, erroProc ); 
   }

   delete_grupos( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.deleteItem("grupos", item, erroProc ); 
   }

   get_fornecedores( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "fornecedores"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_clientes( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "clientes"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   post_clientes( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.postItem("clientes", item, erroProc ); 
   }

   patch_clientes( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.patchItem("clientes", item, erroProc ); 
   }

   get_pessoas( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "pessoas"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_pedidos( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "pedidos"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   post_pedidos( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.postItem("pedidos", item, erroProc ); 
   }

   patch_pedidos( item: any, erroProc:any=null, sucessProc? : Function): Observable<any> { 
      this.configOptions(); 
      return this._odata.patchItem("pedidos", item, erroProc, ((sucessProc) ? sucessProc : undefined) ); 
   }

   get_pedidoEstados( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "pedidoEstados"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   post_pedidoEstados( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.postItem("pedidoEstados", item, erroProc ); 
   }

   patch_pedidoEstados( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.patchItem("pedidoEstados", item, erroProc ); 
   }

   get_kds_itens( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "kds_itens"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_kpi_compras( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "kpi_compras"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_kpi_compras_itens( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "kpi_compras_itens"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_kpi_vendas( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "kpi_vendas"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_kpi_vendas_itens( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "kpi_vendas_itens"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_moedas_cotacao( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "moedas_cotacao"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   put_moedas_cotacao( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.putItem("moedas_cotacao", item, erroProc ); 
   }

   post_moedas_cotacao( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.postItem("moedas_cotacao", item, erroProc ); 
   }

   patch_moedas_cotacao( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.patchItem("moedas_cotacao", item, erroProc ); 
   }

   get_temperatura( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "temperatura"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   put_temperatura( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.putItem("temperatura", item, erroProc ); 
   }

   get_metas_vendas( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "metas_vendas"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   put_metas_vendas( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.putItem("metas_vendas", item, erroProc ); 
   }

   post_metas_vendas( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.postItem("metas_vendas", item, erroProc ); 
   }

   patch_metas_vendas( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.patchItem("metas_vendas", item, erroProc ); 
   }

   get_metas_vendas_vendedor( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "metas_vendas_vendedor"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   put_metas_vendas_vendedor( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.putItem("metas_vendas_vendedor", item, erroProc ); 
   }

   post_metas_vendas_vendedor( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.postItem("metas_vendas_vendedor", item, erroProc ); 
   }

   patch_metas_vendas_vendedor( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.patchItem("metas_vendas_vendedor", item, erroProc ); 
   }

   get_crm_funil( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "crm_funil"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   put_crm_funil( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.putItem("crm_funil", item, erroProc ); 
   }

   post_crm_funil( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.postItem("crm_funil", item, erroProc ); 
   }

   patch_crm_funil( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.patchItem("crm_funil", item, erroProc ); 
   }

   delete_crm_funil( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.deleteItem("crm_funil", item, erroProc ); 
   }

   get_crm_origem( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "crm_origem"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   put_crm_origem( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.putItem("crm_origem", item, erroProc ); 
   }

   post_crm_origem( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.postItem("crm_origem", item, erroProc ); 
   }

   patch_crm_origem( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.patchItem("crm_origem", item, erroProc ); 
   }

   delete_crm_origem( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.deleteItem("crm_origem", item, erroProc ); 
   }

   get_crm_estagio( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "crm_estagio"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   put_crm_estagio( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.putItem("crm_estagio", item, erroProc ); 
   }

   post_crm_estagio( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.postItem("crm_estagio", item, erroProc ); 
   }

   patch_crm_estagio( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.patchItem("crm_estagio", item, erroProc ); 
   }

   delete_crm_estagio( item: any, erroProc:any=null): Observable<any> { 
      this.configOptions(); 
      return this._odata.deleteItem("crm_estagio", item, erroProc ); 
   }

   get_kpi_compras_itens_mensal( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "kpi_compras_itens_mensal"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_kpi_compras_mensal( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "kpi_compras_mensal"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_kpi_crm_oportunidade_abertas( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "kpi_crm_oportunidade_abertas"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_kpi_produtos_fornecedor10( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "kpi_produtos_fornecedor10"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_kpi_produtos_novos( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "kpi_produtos_novos"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_kpi_produtos_promocao( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "kpi_produtos_promocao"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_kpi_temp( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "kpi_temp"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_kpi_vendas_itens_mensal( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "kpi_vendas_itens_mensal"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_kpi_vendas_maisvendidos( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "kpi_vendas_maisvendidos"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_kpi_vendas_mensal( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "kpi_vendas_mensal"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_kpi_venda_caixa_diario( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "kpi_venda_caixa_diario"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_kpi_venda_meiopgto_diario( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "kpi_venda_meiopgto_diario"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_kpi_venda_meiopgto_mensal( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "kpi_venda_meiopgto_mensal"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_web_categorias( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "web_categorias"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_web_marcas( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "web_marcas"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_web_pedidos_abertos( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "web_pedidos_abertos"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_web_produtos( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "web_produtos"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

   get_web_subcategorias( query:ODataBrQuery ):ODataProviderService { 
      this.configOptions(); 
      query.resource = "web_subcategorias"+(query.join?query.join:"");
      return this._odata.getValue( query ); 
   }

}